import { getPrinterName, printRawHex } from './qzPrinter';

var config = process.env;

function apiUrl(id, path) {
    return config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `cafeteria/kitchen-order/${id}/${path}`;
}

// ⚠️ El backend responde TODOS los errores (sesión vencida 1002, comanda inexistente
// 6003, etc.) como HTTP 200 con body JSON {error, message} — r.ok NO alcanza. Este
// helper detecta ese body, avisa al usuario (y redirige al login con 1002) y tira un
// error MARCADO (apiHandled) para que el caller no haga fallback ni re-alerte:
// sin esto, la comanda "imprimía" el JSON del error.
function assertNotApiError(text) {
    const trimmed = (text || '').trim();
    if (trimmed.startsWith('{')) {
        let data = null;
        try {
            data = JSON.parse(trimmed);
        } catch (e) {
            return text; // no era JSON: contenido legítimo
        }
        if (data && Number(data.error) > 0) {
            alert(data.message || 'Error al obtener la comanda.');
            if (Number(data.error) === 1002) {
                window.location.href = localStorage.getItem('homePageURL');
            }
            const error = new Error('api error ' + data.error);
            error.apiHandled = true;
            throw error;
        }
    }
    return text;
}

// Timeout del camino térmico: si QZ Tray está colgado (spooler trabado, diálogo del
// driver), qz.print puede no resolver NUNCA — sin esto no hay fallback ni feedback.
function withTimeout(promise, ms, label) {
    return Promise.race([
        promise,
        new Promise((resolve, reject) => setTimeout(() => reject(new Error(label + ' timeout')), ms)),
    ]);
}

// Camino térmico: trae el ESC/POS crudo (hex) del backend y lo manda a la impresora
// configurada vía QZ Tray. Mejor calidad que el HTML (corte de papel, sin diálogo).
function printComandaThermal(id, printerName) {
    return fetch(apiUrl(id, 'escpos'), {
        headers: { 'access-token': localStorage.getItem('token') },
    })
        .then((r) => {
            if (!r.ok) {
                throw new Error('escpos http ' + r.status);
            }
            return r.text();
        })
        .then(assertNotApiError)
        .then((hex) => {
            if (!/^[0-9a-fA-F]+$/.test((hex || '').trim())) {
                throw new Error('escpos body inválido');
            }
            return withTimeout(printRawHex(printerName, hex.trim()), 6000, 'qz print');
        });
}

// Camino HTML (fallback): trae el HTML de la comanda (autenticado) y lo imprime en un
// iframe SANDBOXED. El backend ya escapa los campos del usuario; el sandbox (sin
// allow-scripts) es defensa en profundidad: aunque el escape regresara, un payload no
// ejecutaría script en el origen del backoffice (donde vive el token). allow-same-origin
// permite que el padre dispare print(); allow-modals habilita el diálogo.
function printComandaHtml(id) {
    return fetch(apiUrl(id, 'print'), {
        headers: { 'access-token': localStorage.getItem('token') },
    })
        .then((r) => {
            if (!r.ok) {
                throw new Error('print http ' + r.status);
            }
            return r.text();
        })
        .then(assertNotApiError)
        .then((html) => {
            const frame = document.createElement('iframe');
            frame.setAttribute('sandbox', 'allow-same-origin allow-modals');
            frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
            frame.onload = () => {
                try {
                    frame.contentWindow.focus();
                    frame.contentWindow.print();
                } catch (e) {
                    // noop
                }
                setTimeout(() => {
                    try { document.body.removeChild(frame); } catch (e) { /* noop */ }
                }, 1000);
            };
            frame.srcdoc = html;
            document.body.appendChild(frame);
        });
}

// Punto de entrada único usado por el POS. Si hay una impresora térmica configurada
// (localStorage 'qzPrinter' o REACT_APP_QZ_PRINTER) imprime por QZ; si no está
// configurada, o QZ falla o se cuelga (timeout), cae al HTML para no dejar al cajero
// sin comanda. Los errores de API (sesión vencida) ya avisaron/redirigieron y NO
// generan fallback (evita doble alert o imprimir el JSON del error).
export function printComanda(id) {
    const printerName = getPrinterName();
    if (printerName) {
        return printComandaThermal(id, printerName).catch((e) => {
            if (e && e.apiHandled) {
                return undefined; // ya se avisó al usuario; sin fallback
            }
            // eslint-disable-next-line no-console
            console.warn('[comanda] impresión térmica falló, uso HTML:', e);
            return printComandaHtml(id).catch((e2) => {
                if (!(e2 && e2.apiHandled)) {
                    alert('No se pudo abrir la comanda para imprimir.');
                }
            });
        });
    }
    return printComandaHtml(id).catch((e) => {
        if (!(e && e.apiHandled)) {
            alert('No se pudo abrir la comanda para imprimir.');
        }
    });
}
